import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"

import "./section-darkmode-split-content-v2.scss"

const SectionDarkmodeSplitContentV2 = ({
  ctaButton,
  image,
  mobileImage,
  mobileText,
  text,
  title,
}) => {
  return (
    <section className="section-darkmode-split-content-v2">
      <div className="container-v2">
        <div className="section-darkmode-split-content-v2--content">
          {title && (
            <h2 className="section-darkmode-split-content-v2--title">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}
          <div
            className="section-darkmode-split-content-v2--text"
            dangerouslySetInnerHTML={{
              __html: text?.childrenMarkdownRemark?.[0]?.html,
            }}
          />
          {ctaButton && (
            <p className="section-darkmode-split-content-v2--cta-button-wrapper">
              <ButtonV2
                accessibilityLabel={ctaButton?.accessibilityLabel}
                className={getButtonClasses(
                  ctaButton?.buttonStyle || "primary-green",
                  ctaButton?.buttonSize || "large"
                )}
                href={ctaButton?.path}
                key={ctaButton?.id}
                showArrow={ctaButton?.showArrow === "Yes" ? true : false}
                text={ctaButton?.text}
              />
            </p>
          )}
        </div>
        {image?.fluid && (
          <div className="section-darkmode-split-content-v2--image-wrapper">
            <div className="section-darkmode-split-content-v2--image">
              <Image image={image?.fluid} />
            </div>
            {ctaButton && (
              <p className="section-darkmode-split-content-v2--cta-button-wrapper">
                <ButtonV2
                  accessibilityLabel={ctaButton?.accessibilityLabel}
                  className={getButtonClasses(
                    ctaButton?.buttonStyle || "primary-green",
                    ctaButton?.buttonSize || "large"
                  )}
                  href={ctaButton?.path}
                  key={ctaButton?.id}
                  showArrow={ctaButton?.showArrow === "Yes" ? true : false}
                  text={ctaButton?.text}
                />
              </p>
            )}
          </div>
        )}
        {/* mobile image and text */}
        <div className="section-darkmode-split-content-v2--mobile-content">
          {mobileImage?.fluid && (
            <div className="section-darkmode-split-content-v2--image-mobile">
              <Image image={mobileImage?.fluid} />
            </div>
          )}
          {mobileText?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-darkmode-split-content-v2--text-mobile"
              dangerouslySetInnerHTML={{
                __html: mobileText?.childrenMarkdownRemark?.[0]?.html,
              }}
            />
          )}
        </div>
      </div>
    </section>
  )
}

SectionDarkmodeSplitContentV2.propTypes = {
  ctaButton: PropTypes.object,
  image: PropTypes.object,
  mobileImage: PropTypes.object,
  mobileText: PropTypes.object,
  text: PropTypes.object,
  title: PropTypes.string,
}

export default SectionDarkmodeSplitContentV2
